import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export const CookieConsent = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("yt_consent")) setVisible(true);
    }, []);

    const choose = (value) => {
        localStorage.setItem("yt_consent", value);
        setVisible(false);
    };

    if (!visible) return null;

    return (
        <div data-testid="cookie-consent" className="fixed inset-x-0 bottom-0 z-[70] border-t border-gold/40 bg-espresso text-sand">
            <div className="mx-auto flex max-w-7xl flex-col gap-4 px-6 py-5 md:flex-row md:items-center md:justify-between lg:px-10">
                <p className="max-w-2xl text-sm leading-relaxed text-sand/80">
                    We use a few cookies to keep your shopping bag working — and, only with your OK, anonymous visit
                    stats that help us improve the shop. No ads, no data selling, ever.{" "}
                    <Link to="/privacy" data-testid="cookie-privacy-link" className="text-gold underline underline-offset-4 transition-colors hover:text-sand">
                        Privacy policy
                    </Link>
                </p>
                <div className="flex shrink-0 gap-3">
                    <button
                        onClick={() => choose("declined")}
                        data-testid="cookie-decline"
                        className="border border-sand/40 px-6 py-3 font-mono text-[10px] uppercase tracking-[0.2em] transition-colors duration-300 hover:bg-sand hover:text-espresso"
                    >
                        Essential only
                    </button>
                    <button
                        onClick={() => choose("accepted")}
                        data-testid="cookie-accept"
                        className="bg-gold px-6 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-espresso transition-colors duration-300 hover:bg-sand"
                    >
                        Accept
                    </button>
                </div>
            </div>
        </div>
    );
};
